
export const Width = {
  WIDE: "1900px",
  NORMAL: "800px"
}